const initialState = 1;

const phonesPaginationTenantAdminReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_PHONES_TENANT_ADMIN_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default phonesPaginationTenantAdminReducer;